export default from './search-page';



// WEBPACK FOOTER //
// ./app/containers/search-page/index.js